export enum OrderPaymentStatusEnum {
    AWAITING = 1,
    PAID,
    AT_CHECKOUT,
    OVERDUE
}